import "./Prava.css";

export default function Prava() {
  return (
    <div className="prava">
      <div className="footer__prava">© 2026 Codextech. Все права защищены.</div>
    </div>
  );
}
